import { logger } from '@zep/core-logger';

import type { GetQuizsetRankingsPeriod } from '@/api/gen/_model/getQuizsetRankingsPeriod';
import { type QuizListType } from '@/shared/quizList/QuizListType';
import { type CommonTranslationKeys } from '@/types/translation';
const track = ({
  period,
  schoolType,
  location,
}: FeaturedLogPayload & { period: string }) => {
  logger.track('featured_click', {
    period,
    schoolType,
    location,
  });
};

type FeaturedLogPayload = {
  schoolType: string;
  location: QuizListType;
};

export const FeaturedPeriods: {
  name: CommonTranslationKeys;
  value: FeaturedPeriod;
  track: (payload: FeaturedLogPayload) => void;
}[] = [
  {
    name: 'range.daily',
    value: 'DAILY',
    track: payload => {
      track({
        period: 'DAILY',
        ...payload,
      });
    },
  },
  {
    name: 'range.weekly',
    value: 'WEEKLY',
    track: payload => {
      track({
        period: 'WEEKLY',
        ...payload,
      });
    },
  },
  {
    name: 'range.monthly',
    value: 'MONTHLY',
    track: payload => {
      track({
        period: 'MONTHLY',
        ...payload,
      });
    },
  },
];

export type FeaturedPeriod = GetQuizsetRankingsPeriod;
